import { FuuzeColors, FuuzeText, FuuzeTooltip, FuuzeTooltipDefaultTrigger } from '@fuuze/shared';
import { useTranslation } from 'react-i18next';
import { IoSettingsOutline, IoWarning } from 'react-icons/io5';
import { useLocation } from 'react-router-dom';
import { useUser } from '../../../Hooks/use-user.hook';
import commonStyles from '../../../styles/common.module.css';
import { FuuzeNavLink } from '../fuuze-nav-link';

export function NavBarSettingsLink() {
  const { t } = useTranslation('components:leftNav', { keyPrefix: 'menuContent' });
  const { pathname } = useLocation();
  const user = useUser();

  const showWarning = user.data?.isAnySubscriptionHasIssue() || user.data?.hasOngoingSubscriptionsButNoPaymentMethods();

  return (
    <FuuzeNavLink
      Icon={IoSettingsOutline}
      active={pathname.startsWith('/settings')}
      title={
        showWarning ? (
          <div className={commonStyles.FlexRow} style={{ gap: 8 }}>
            <FuuzeText as='span'>{t('settings')}</FuuzeText>
            <FuuzeTooltip
              render={
                <FuuzeTooltipDefaultTrigger
                  hideHelpIcon
                  text={<IoWarning fill={FuuzeColors.orange.orange80} size={20} />}
                />
              }
            >
              {t('subscriptionHasIssueWarningTooltip')}
            </FuuzeTooltip>
          </div>
        ) : (
          t('settings')
        )
      }
      path='/settings'
    />
  );
}
